export const checkMinValue = (value) => {
    const regex = /^.{8,}$/;

    return regex.test(value);
};

export const checkCaseCharacter = value => {
    const regex = /^(.*[a-zA-Z].)/;

    return regex.test(value);
};

export const checkDigit = value => {
    const regex = /(.*\d.*)/;

    return regex.test(value);
};

export const checkSpecialCharacter = value => {
    const regex = /(.*?[#?!@$%^&*-/])/;
    return regex.test(value);
};

export const checkPassword = value => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return regex.test(value);
};